import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    iframe: {
        width: '100%',
        height: '800px',
        border: '0'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ContractContentWidgetDialog(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const signEntrypoint = process.env.REACT_APP_BASE_ENTRYPOINT + '/contract/programs/' + props.contractNumber
        + '?token=' + localStorage.getItem('session');

    const handleClickOpen = () => {
        window.open(signEntrypoint, '_blank');
        //setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button variant="outlined" color="primary" onClick={handleClickOpen}>
                Переглянути текст договору
            </Button>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Tекст договору
                        </Typography>
                        <Button autoFocus color="inherit" onClick={handleClose}>
                            Закрити
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <iframe id="contract" name="contract" src={signEntrypoint} className={classes.iframe}></iframe>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    );
}